import { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../../constants/icons';

import './EmailVerificationTemplate.css';

export const EmailVerificationTemplate = memo(() => {
  const { t } = useTranslation();
  return (
    <div className="email-verification">
      <div className="centered-container">
        <section>
          <div className="text-content">
            <img className="tick-icon" src={Icons[IconType.Tick]} />
            <p className="text-3xl font-bold">
              {t('You’ve Successfully Verified Your Email Address!')}
            </p>
            <p>
              {t(
                'Congratulations! You’ve successfully verified your email address for your JOYAJOY Account.',
              )}
            </p>
            <div className="visit-again">
              <Trans i18nKey="Please visit app.joyajoy.com to log in again.">
                Please visit
                <a className="visit-link" href="https://app.joyajoy.com">
                  app.joyajoy.com
                </a>
                to log in again.
              </Trans>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
});
